// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca7c5920","239":"fdc3974e","453":"9d631450","455":"10c0300b"}[chunkId] + ".chunk.js";
};